const pdfjs = require('pdfjs-dist/legacy/build/pdf.js');

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

export default pdfjs;
